import { render, staticRenderFns } from "./ConfirmWithWallet.vue?vue&type=template&id=d97c67fc&scoped=true&"
import script from "./ConfirmWithWallet.vue?vue&type=script&lang=js&"
export * from "./ConfirmWithWallet.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmWithWallet.vue?vue&type=style&index=0&id=d97c67fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97c67fc",
  null
  
)

export default component.exports